export default [
    {
      path: '/admin/reports/finances/driver-transaction-summaries',
      name: 'driver-transaction-summary',
      meta: { requiresAuth: true },
      component: () => import('@/pages/report/finance/driver-transaction-summary.vue')
    }
  ]
